// src/utils/card-description.ts
var CARD_DESCRIPTION_MAX = 255;
var CARD_DESCRIPTION_LIMIT_MESSAGE = `Card descriptions are capped at ${CARD_DESCRIPTION_MAX} characters \u2014 write 1-2 plain sentences a non-engineer can read; put technical detail in the plan or card chat.`;
var CARD_DESCRIPTION_FIELD_HINT = `max ${CARD_DESCRIPTION_MAX} chars, 1-2 plain sentences a non-engineer can read \u2014 put technical detail in the plan`;
var DIVIDER = /^\s*-{3,}\s*$/m;
function clampDescription(text, max = CARD_DESCRIPTION_MAX) {
  const trimmed = text?.trim() ?? "";
  if (trimmed.length <= max) return trimmed;
  const slice = trimmed.slice(0, max - 1);
  const lastSpace = slice.lastIndexOf(" ");
  const head = lastSpace > max * 0.6 ? slice.slice(0, lastSpace) : slice;
  return `${head.replace(/[\s.,;:—-]+$/, "")}\u2026`;
}
function clampDescriptionField(value) {
  return typeof value === "string" ? clampDescription(value) : value;
}
function collapse(text) {
  return text.replace(/\s*\n\s*/g, " ").trim();
}
function summarizeReportBody(body, max = CARD_DESCRIPTION_MAX) {
  const raw = body?.trim();
  if (!raw) return "";
  const divider = DIVIDER.exec(raw);
  const withoutFooter = (divider ? raw.slice(0, divider.index) : raw).trim();
  const source = withoutFooter.length > 0 ? withoutFooter : raw;
  const oneLine = collapse(source);
  if (oneLine.length <= max) return oneLine;
  const firstParagraph = collapse(source.split(/\n\s*\n/)[0]);
  return clampDescription(firstParagraph.length > 0 ? firstParagraph : oneLine, max);
}

export {
  CARD_DESCRIPTION_MAX,
  CARD_DESCRIPTION_LIMIT_MESSAGE,
  CARD_DESCRIPTION_FIELD_HINT,
  clampDescription,
  clampDescriptionField,
  summarizeReportBody
};
